import client from "./client";

export const fetchResortStatuses = () => client.get("/resorts/status").then((r) => r.data.statuses);

export const reportResortStatus = (resortId, flagType, message) =>
  client.post(`/resorts/${resortId}/status`, { flagType, message }).then((r) => r.data);

export const clearResortStatus = (resortId) =>
  client.delete(`/resorts/${resortId}/status`).then((r) => r.data);
